<template>
  <v-form ref="form5">
    <div class="d-flex flex-column ga-6">
      <span class="text-heading text-primary text-bold">Doel</span>
      <v-card class="card w-100 d-flex flex-column ga-10" flat>
        <div class="d-flex flex-column ga-4">
          <span class="text-normal text-primary">Wat is jouw doel?</span>
          <v-radio-group class="mt-4" v-model="localQuestions['Wat is jouw doel?']"
            :rules="[rules.select_rules.required]">
            <v-radio class="radio-btn-rounded" color="secondary" label="Afvallen" value="afvallen" />
            <v-radio class="radio-btn-rounded" color="secondary" label="Aankomen" value="aankomen" />
            <v-radio class="radio-btn-rounded" color="secondary" label="Stabiel blijven" value="stabiel blijven" />
          </v-radio-group>
        </div>

        <div class="d-flex flex-column ga-4 mt-n6">
          <span class="text-normal text-primary">Je gewenste streefgewicht?</span>
          <v-text-field :rules="[rules.text_field_rules.required]"
            v-model="localQuestions['Je gewenste streefgewicht?']" color="secondary" base-color="secondary"
           variant="underlined">
            <template v-slot:append-inner>
              <div class="">
                <span class="text-normal text-secondary">KG</span>
              </div>
            </template>
          </v-text-field>
        </div>
      </v-card>
    </div>
  </v-form>
</template>

<script>
import FormRules from "@/util/FormRules";

export default {
  props: {
    questions: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      rules: FormRules.rules,
      localQuestions: { ...this.questions },
    };
  },
  methods: {
    nextStep() {
      this.$emit("nextStep", this.geslacht);
    },
  },
  watch: {
    // Watch for changes in localQuestions and emit updates to the parent
    localQuestions: {
      deep: true,
      handler(newVal) {
        this.$emit("update-questions", newVal);
      },
    },
  },
};
</script>
